import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IMainStrings extends LocalizedStringsMethods {
    lsSettingsTxt: string;
    lsLogOutTxt: string;
    lsHomeTxt: string;
    lsOrgTxt: string;
    lsOrgsTxt: string;
    lsManageUsrTxt: string;
    isReportTxt: String;
    lsManageOrgTxt: string;
    lsProfilesTxt: string;
    lsTestTxt: string;
    lsSharedDataTxt: string;
    lsEmpTxt: string;
    lsReportsTxt: string;
    lsReport1Txt: string;
    lsReport2Txt: string;
    lsAuditTxt: string;
    lsLogoutFromTxt: string;
    lsSelectOrgtxt: string;
    lsLoginAsTxt: string;
    lsLoggedInErrTxt: string;
    lsEyeGuideTxt: string;
    lsCusTxt: string;
}

let strings: IMainStrings;
export default strings = new LocalizedStrings({
    en: {        
        lsSettingsTxt: 'Settings',
        lsLogOutTxt: 'Logout',
        lsHomeTxt: 'Home',
        lsOrgTxt: 'Organization',
        lsOrgsTxt: 'Organizations',
        lsManageUsrTxt: 'Manage Users',
        isReportTxt:    'Reports',
        lsManageOrgTxt: 'Manage Organization',
        lsProfilesTxt: 'Profiles',
        lsTestTxt: 'Tests',
        lsSharedDataTxt: 'Shared Data',
        lsEmpTxt: 'Employees',
        lsCusTxt: 'Customers',
        lsReportsTxt: 'Reports',
        lsReport1Txt: 'Reports',
        lsReport2Txt: 'Reports',
        lsAuditTxt: 'Audit',
        lsLogoutFromTxt: 'Logout from',
        lsSelectOrgtxt: 'Select Organization',
        lsLoginAsTxt: 'Login As',
        lsLoggedInErrTxt: 'you are logged in with some other organization',
        lsEyeGuideTxt: 'EYEGUIDE'
    },
    es: {        
        lsSettingsTxt: 'Configuraciones',
        lsLogOutTxt: 'Cerrar sesión',
        lsHomeTxt: 'Casa',
        lsOrgTxt: 'Organización',
        lsOrgsTxt: 'Organizaciones',
        lsManageUsrTxt: 'Administrar usuarios',
        isReportTxt:    'Reports',
        lsManageOrgTxt: 'Administrar organización',
        lsProfilesTxt: 'Perfiles',
        lsTestTxt: 'Pruebas',
        lsSharedDataTxt: 'Datos compartidos',
        lsEmpTxt: 'Empleado',
        lsReportsTxt: 'Informes',
        lsReport1Txt: 'Informe1',
        lsReport2Txt: 'Informe2',
        lsAuditTxt: 'Auditoría',
        lsLogoutFromTxt: 'Salir de',
        lsSelectOrgtxt: 'Seleccionar organización',
        lsLoginAsTxt: 'Iniciar sesión como',
        lsLoggedInErrTxt: 'has iniciado sesión con alguna otra organización',
        lsEyeGuideTxt: 'GUÍA DE OJOS',
        lsCusTxt: 'Clientes'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/strings.main.tsx